<script lang="ts">
	import UnitManagement from 'src/components/Settings/HomeManagement/UnitManagement.svelte';
	import SharedHomesToMeList from 'src/components/Settings/HomeManagement/SharedHomesToMeList.svelte';
</script>

<UnitManagement />
<SharedHomesToMeList />
